'use strict'

import {
    serverApi
} from '@/server';


export default {
    /**
     * 获取商户下的角色名
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: api/select-roles
     */
    getRolesSelectList(formData) {
        let url = `/select-roles`;
        return serverApi.get(formData, url);
    },
    /**
     * 获取用户管理列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/users
     */
    getUserList(formData) {
        const url = `/users`;
        return serverApi.get(formData, url);
    },
    /**
    * 添加用户第一步，验证手机号
    *
    * @author wang & 2019-7-4 14:54:51
    *
    * @method POST
    *
    * @url: /api/users
    */
    nextStepUser(formData) {
        const url = `/phone-merchants`;
        return serverApi.post(formData, url);
    },
    /**
     * 添加用户
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     *
     * @url: /api/users
     */
    addUserList(formData) {
        const url = `/users`;
        return serverApi.post(formData, url);
    },
    /**
     * 用户编辑 - 返回编辑用户的信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/users/1/edit
     */
    getUserInfo(id) {
        const url = `/users/${id}/edit`;
        return serverApi.get({}, url);
    },

    /**
     * 用户编辑 - 更新用户信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /api/users/1
     */
    editUserInfo(formData, id) {
        const url = `/users/${id}`;
        return serverApi.put(formData, url);
    },



    /**
     * 绑定角色 - 获取需要绑定角色的用户信息和角色列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/users/1/edit
     */
    getEditUserInfo(id) {
        const url = `/users/${id}/edit`;
        return serverApi.get({}, url);
    },
    /**
     * 用户绑定角色
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /api/user-has-roles/1
     */
    editUserRole(formData, id) {
        const url = `/user-has-roles/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 禁用/启用用户
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /api/user-states/1
     */
    userForbiddenLogin(formData, id) {
        const url = `/user-forbidden-login/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 获取角色列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/roles
     */
    getRolesList(formData) {
        const url = `/roles`;
        return serverApi.get(formData, url);
    },
    /**
     * 添加角色
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     *
     * @url: /api/roles
     */
    addRolesList(formData) {
        const url = `/roles`;
        return serverApi.post(formData, url);
    },
    /**
     * 编辑角色 - 更新角色
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /api/roles/2
     */
    editRolesList(formData, id) {
        const url = `/roles/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 编辑角色 - 获取要编辑的角色数据
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/roles/2/edit
     */
    getEditRolesInfo(id) {
        const url = `/roles/${id}/edit`;
        return serverApi.get({}, url);
    },
    /**
     * 删除角色
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method DELETE
     *
     * @url: /api/roles/3
     */
    deleteRoles(id) {
        const url = `/roles/${id}`;
        return serverApi.delete(url);
    },
    /**
     * 授权 - 用户编辑-返回编辑用户的信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/role-has-permissions/1/edit
     */
    getPermissionsList(id) {
        const url = `/role-has-permissions/${id}/edit`;
        return serverApi.get({}, url);
    },
    /**
     * 授权 - 更新角色权限信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /api/role-has-permissions/1
     */
    updateRoleHasPermissions(formData, id) {
        const url = `/role-has-permissions/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 获取登陆用户信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /api/auth/me
     */
    getAuthInfo() {
        const url = `/auth/me`;
        return serverApi.get({}, url);
    },
    /**
     * 刷新token-- --登录状态维系
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     *
     * @url: /auth/refresh
     */
    getAuthRefresh() {
        const url = `/auth/refresh`;
        return serverApi.post({}, url);
    },
    /**
     * 登录手机号更换-- - 获取源手机号验证码
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     *
     * @url: /user-origin-code
     */
    getUserOriginCode(formData) {
        const url = `/user-origin-code`;
        return serverApi.post(formData, url);
    },
    /**
     * 登录手机号更换-- --获取新绑定手机验证码
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     *
     * @url: /user-new-code
     */
    getUserNewCode(formData) {
        const url = `/user-new-code`;
        return serverApi.post(formData, url);
    },
    /**
     * 登录手机号更换-- - 更换动作 成功后请 退出
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /user-change-account/${id}
     */
    getUserChangeAccount(formData, id) {
        const url = `/user-change-account/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 用户启用、禁用--释放手机号
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method PUT
     *
     * @url: /user-states/{id}
     */
    userEnabled(formData, id) {
        const url = `/user-states/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 解除绑定的微信
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method get
     *
     * @url: /spa/user-enabled/{id}
     */
    wechatRemove() {
        const url = `/wechat-release`;
        return serverApi.get({}, url);
    },

    /**
     * 二維碼
     */
    getWxSubCode() {
        const url = `/wechat-qrcode`;
        return serverApi.preview({}, url, { responseType: 'blob' });
    },
    /**
     * 验证此手机号下是否已绑定其它用户
     */
    isHasUser(formData) {
        const url = `/phone-merchants`;
        return serverApi.post(formData, url);
    },
    /**
     * 商户添加短信验证码
     */
    getUserVaildCode(formData) {
        const url = `/user-code`;
        return serverApi.post(formData, url);
    },
    /**
     * 添加关联商户
     */
    getUserVaild(formData) {
        const url = `/user-account`;
        return serverApi.post(formData, url);
    },
    /**
     * 修改手机号验证
     */
    editUserPhone(formData) {
        const url = `/change-phone`;
        return serverApi.post(formData, url);
    },
    /**
     * 修改默认登录公司
     */
    changeDefauleCompany(formData, id) {
        const url = `/merchant-default/${id}`;
        return serverApi.put(formData, url);
    },
    /**
     * 切换商户
     */
    changeUser(formData) {
        const url = `/switch-merchant`;
        return serverApi.post(formData, url);
    }
}
